<template>
  <div>
    <dialogPack v-model:isView="isShow" width="80%" title="权限管理">
      <template v-slot:body>
        <div
          class="organizationMain"
          v-loading="loading"
          element-loading-text="数据加载中"
        >
          <!-- 左边区域 -->
          <div class="leftMenu">
            <div class="menuList">
              <ul>
                <li
                  :class="active == index ? 'active' : ''"
                  v-for="(item, key, index) in roleGrouplist"
                  :key="item.id"
                  @click="getrolelistEvent(key, index)"
                >
                  <span>{{ item }}</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 右边区域 -->
          <div class="rightAppManager">
            <!-- 顶部操作区域 -->
            <el-row class="AppManager-title">
              <el-col :span="24"
                ><el-button type="text" size="mini" @click="goBack(1)">{{
                  data.pname
                }}</el-button>
                /<el-button type="text" size="mini" :disabled="true">{{
                  data.name
                }}</el-button>
              </el-col>
            </el-row>
            <!-- <div class="AppManager" v-loading="loading" v-if="key!='report'&&key!='approval'">
                <div v-for="(item,key) in showData" :key="item.id" class="AppManager-list">
                  <p style="padding:0 10px 6px;color:#4e86ff;font-size:16px">{{item.categoryName}}</p>
                  <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.checkAll" @change="handleCheckAllChange(item.checkAll,key)" style="margin-left:10px">全选</el-checkbox>
                  <el-checkbox-group v-model="item.checkedValues" @change="handleCheckedCitiesChange(item.checkedValues,key)">
                    <el-checkbox v-for="item1 in item.values" :label="item1.id" :key="item1.id" style="margin:8px 10px 0">{{item1.name}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div> -->
            <div class="AppManager">
              <!--数据汇报及权限管理个人和学校-->
              <template v-if="type != 'approval'">
                <div
                  v-for="(item, key) in showData"
                  :key="item.id"
                  class="AppManager-list"
                >
                  <div class="tit">
                    <span>{{ item.categoryName }}</span>
                  </div>
                  <div class="con">
                    <div class="databox" v-if="item.values && item.values.length > 0">
                      <div class="checkboxGroup">
                        <p v-if="item.myvalues">全校数据</p>
                        <el-checkbox-group
                          v-model="item.checkedValues"
                          @change="handleCheckedCitiesChange(item.checkedValues, key)"
                        >
                          <el-checkbox
                            v-for="item1 in item.values"
                            :label="item1.id"
                            :key="item1.id"
                            >{{ item1.name }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </div>
                      <div class="checkAllBox">
                        <el-checkbox
                          :indeterminate="item.isIndeterminate"
                          v-model="item.checkAll"
                          @change="handleCheckAllChange(item.checkAll, key)"
                          >全选</el-checkbox
                        >
                      </div>
                    </div>
                    <div
                      class="databox bt-eee"
                      v-if="item.myvalues && item.myvalues.length > 0"
                    >
                      <div class="checkboxGroup">
                        <p>个人数据</p>
                        <el-checkbox-group
                          v-model="item.checkedMyvalues"
                          @change="
                            handleCheckedCitiesChange(item.checkedMyvalues, key, 1)
                          "
                        >
                          <el-checkbox
                            v-for="item1 in item.myvalues"
                            :label="item1.id"
                            :key="item1.id"
                            style="margin: 8px 10px 0"
                            >{{ item1.name }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </div>
                      <div class="checkAllBox">
                        <el-checkbox
                          :indeterminate="item.isIndeterminates"
                          v-model="item.checkAlls"
                          @change="handleCheckAllChange(item.checkAlls, key, 1)"
                          >全选</el-checkbox
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="approvalBox" v-else>
                <div class="nav">
                  <p
                    v-for="(item, key) in showData"
                    :key="item.id"
                    @click="navClick(key)"
                    :class="key == listKey ? 'active' : ''"
                  >
                    {{ item.categoryName }}
                  </p>
                </div>
                <div class="list">
                  <div class="tit">
                    <el-checkbox v-model="allChecked" @change="allCheck">全选</el-checkbox>
                    <el-tooltip class="item" effect="dark" content="全选是全选应用" placement="top">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                    <span>已选择<span style="color: #4e86ff;margin:0;">{{checkedApps.length}}</span>个应用</span>
                    <el-button type="primary" @click="openEdit">批量操作</el-button>
                  </div>
                  <div
                    class="list_d"
                    v-for="item1 in showData[listKey].values"
                    :key="item1.id"
                  >
                    <div class="name">
                      <p>
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="item1.name"
                          placement="top-start"
                        >
                          <el-checkbox
                            v-model="item1.nameCheck"
                            >{{ item1.name }}</el-checkbox
                          >
                        </el-tooltip>
                      </p>
                    </div>
                    <div class="rightList">
                      <div>
                        <el-checkbox v-model="item1.approvalid">填写</el-checkbox>
                        <el-checkbox v-model="item1.uncomplete">未填统计</el-checkbox>
                        <el-checkbox v-model="item1.blockchain"
                          >区块链统计</el-checkbox
                        >
                        <el-checkbox v-model="item1.chaindatacontrast"
                          >区块链数据对比</el-checkbox
                        >
                      </div>
                      <div class="schoolData">
                        <p class="name-t">
                          <el-checkbox v-model="item1.myreportForm"
                            >我的数据</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.deletemyreport"
                            @change="reportFormCheck(item1.deletemyreport, item1, 1)"
                            >删除</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.updatemyreport"
                            @change="reportFormCheck(item1.updatemyreport, item1, 1)"
                            >修改</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.importmyreport"
                            @change="reportFormCheck(item1.importmyreport, item1, 1)"
                            >批量导入</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.exportmyfile"
                            @change="reportFormCheck(item1.exportmyfile, item1, 1)"
                            >导出附件</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.uploadmyblockchain"
                            @change="
                              reportFormCheck(item1.uploadmyblockchain, item1, 1)
                            "
                            >上传区块链</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.batchupdatemine"
                            @change="
                              reportFormCheck(item1.batchupdatemine, item1, 1)
                            "
                            >批量修改</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.archivemine"
                            @change="
                              reportFormCheck(item1.archivemine, item1, 1)
                            "
                            >数据归档</el-checkbox
                          >
                        </p>
                      </div>
                      <div class="schoolData">
                        <p class="name-t">
                          <el-checkbox v-model="item1.reportForm"
                            >全部数据</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.deletereport"
                            @change="reportFormCheck(item1.deletereport, item1, 2)"
                            >删除</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.updatereport"
                            @change="reportFormCheck(item1.updatereport, item1, 2)"
                            >修改</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.importreport"
                            @change="reportFormCheck(item1.importreport, item1, 2)"
                            >批量导入</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.exportreport"
                            @change="reportFormCheck(item1.exportreport, item1, 2)"
                            >批量导出</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.exportfile"
                            @change="reportFormCheck(item1.exportfile, item1, 2)"
                            >导出附件</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.uploadblockchain"
                            @change="
                              reportFormCheck(item1.uploadblockchain, item1, 2)
                            "
                            >上传区块链</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.batchupdate"
                            @change="
                              reportFormCheck(item1.batchupdate, item1, 2)
                            "
                            >批量修改</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.archive"
                            @change="
                              reportFormCheck(item1.archive, item1, 2)
                            "
                            >数据归档</el-checkbox
                          >
                        </p>
                      </div>
                      <div class="schoolData">
                        <p class="name-t">
                          <el-checkbox v-model="item1.scope"
                            >管辖范围</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.deletescope"
                            @change="reportFormCheck(item1.deletescope, item1, 3)"
                            >删除</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.updatescope"
                            @change="reportFormCheck(item1.updatescope, item1, 3)"
                            >修改</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.importscope"
                            @change="reportFormCheck(item1.importscope, item1, 3)"
                            >批量导入</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.exportscope"
                            @change="reportFormCheck(item1.exportscope, item1, 3)"
                            >批量导出</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.exportscopefile"
                            @change="reportFormCheck(item1.exportscopefile, item1, 3)"
                            >导出附件</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.uploadscopeblockchain"
                            @change="
                              reportFormCheck(item1.uploadscopeblockchain, item1, 3)
                            "
                            >上传区块链</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.batchupdatescope"
                            @change="
                              reportFormCheck(item1.batchupdatescope, item1, 3)
                            "
                            >批量修改</el-checkbox
                          >
                        </p>
                        <p>
                          <el-checkbox
                            v-model="item1.archivescope"
                            @change="
                              reportFormCheck(item1.archivescope, item1, 3)
                            "
                            >数据归档</el-checkbox
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部按钮 -->
        <div class="bottom-btn" style="text-align: right">
          <el-button type="primary" size="mini" @click="save">保 存</el-button>
          <el-button plain size="mini" @click="goBack">返 回</el-button>
        </div>
      </template>
    </dialogPack>
    <!-- 批量选择的弹框 -->
    <pop-up
      v-model:isView="isEdit"
      title="批量修改权限"
      width="70%"
      @submit="batchEidtSave"
      @close="batchEidtClose"
    >
      <template v-slot:body>
        <div class="batch-eidt-box">
          <!-- 已选择的应用 -->
          <div class="batch-eidt-box-left">
            <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
              <!-- 选中应用的分类 -->
              <ul v-for="(key, keyIndex) in Object.keys(categoryChecked)" :key="keyIndex">
                <p>
                  <i class="WSiconfont WSicon-Document" />
                  <span>{{key}}</span>
                </p>
                <!-- 选中应用 -->
                <li v-for="(item, index) in categoryChecked[key]" :key="index">{{item.name}}</li>
              </ul>
            </el-scrollbar>
          </div>
          <!-- 操作区域 -->
          <div class="batch-eidt-box-right">
             <div class="checkbox-group" v-for="key in ['comon', 'personData', 'allData', 'governData']" :key="key">
                <el-checkbox 
                  v-for="(item, index) in powerGroup[key]" 
                  v-model="powerObj[item.value]"
                  @change="(val)=>{batchChange(val, item.value, key)}"
                  :key="index"> 
                  {{item.lable}}</el-checkbox>
             </div>
          </div>
        </div>
      </template>
    </pop-up>
  </div>
</template>

<script>
import { axiosBase } from "@/api/api";
import { defineAsyncComponent } from "vue";

export default {
  name: 'organizationMain',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: {},
      allChecked: false,
      active: 0,
      type: '',
      authorization: false, //权限设置组建
      loading: true,
      roleGrouplist: {}, //角色组
      pers: null, //已有权限定义
      showData: [], //显示的定义
      listKey: 0,
      roleId: null,
      isShow: false,
      isEdit: false,
      isSpace: false, // 是否从空间进入
      powerGroup: {
        comon: [
          {value:'approvalid', lable:'填写'},
          {value:'uncomplete', lable:'未填统计'},
          {value:'blockchain', lable:'区块链统计'},
          {value:'chaindatacontrast', lable:'区块链数据对比'},
          ],
        personData: [
          {value:'myreportForm', lable:'我的数据'},
          {value:'deletemyreport', lable:'删除'},
          {value:'updatemyreport', lable:'修改'},
          {value:'importmyreport', lable:'批量导入'},
          {value:'exportmyfile', lable:'导出附件'},
          {value:'uploadmyblockchain', lable:'上传区块链'},
          {value:'batchupdatemine', lable:'批量修改'},
          {value:'archivemine', lable:'数据归档'},
          ],
        allData: [
          {value:'reportForm', lable:'全部数据'},
          {value:'deletereport', lable:'删除'},
          {value:'updatereport', lable:'修改'},
          {value:'importreport', lable:'批量导入'},
          {value:'exportreport', lable:'批量导出'},
          {value:'exportfile', lable:'导出附件'},
          {value:'uploadblockchain', lable:'上传区块链'},
          {value:'batchupdate', lable:'批量修改'},
          {value:'archive', lable:'数据归档'},
          ],
        governData: [
          {value:'scope', lable:'管辖范围'},
          {value:'deletescope', lable:'删除'},
          {value:'updatescope', lable:'修改'},
          {value:'importscope', lable:'批量导入'},
          {value:'exportscope', lable:'批量导出'},
          {value:'exportscopefile', lable:'导出附件'},
          {value:'uploadscopeblockchain', lable:'上传区块链'},
          {value:'batchupdatescope', lable:'批量修改'},
          {value:'archivescope', lable:'数据归档'},
        ]
      },
      powerObj: {
        // 公共的数据
        approvalid: false,
        uncomplete: false,
        blockchain: false,
        chaindatacontrast: false,
        // 个人数据
        myreportForm: false,
        deletemyreport: false,
        updatemyreport: false,
        importmyreport: false,
        exportmyfile: false,
        uploadmyblockchain: false,
        batchupdatemine: false,
        archivemine: false,
        // 全部数据
        reportForm: false,
        deletereport: false,
        updatereport: false,
        importreport: false,
        exportreport: false,
        exportfile: false,
        uploadblockchain: false,
        batchupdate: false,
        archive: false,
        // 管辖范围
        scope: false,
        deletescope: false,
        updatescope: false,
        importscope: false,
        exportscope: false,
        exportscopefile: false,
        uploadscopeblockchain: false,
        batchupdatescope: false,
        archivescope: false,
      }
    }
  },
  computed: {
    // 已选择的应用
    checkedApps() {
      let tempList = []
      if(this.showData[this.listKey]&&this.showData[this.listKey].values!==undefined){
        this.showData.forEach(x => {
          tempList.push(...x.values.filter(e => {return e.nameCheck}))
        })
      }
      return tempList
    },
    // 已选择的应用(分类)
    categoryChecked() {
      return this.groupBy(this.checkedApps, 'categoryName')
    }
  },
  watch: {
    show: {
      handler (val) {
        this.isShow = val
      },
      immediate: true
    },
    isShow: {
      handler (val) {
        if (!val) {
          this.$emit('update:show', false)
        }
      }
    },
    checkedApps: {
      handler(val) {
        if(this.showData[this.listKey]&&
          this.showData[this.listKey].values!==undefined&&
          this.showData[this.listKey].values.length === val.length) {
          this.allChecked = true
        }
      },
      immediate: true
    }
  },
  components: {
    dialogPack: defineAsyncComponent(() => import('./common/dialogPack.vue')),
    PopUp: defineAsyncComponent(() => import('@/components/common/popUp.vue'))

  },
  created () {
    const path = this.$route.path
    if (path && path.indexOf('spaceMain') > -1) this.isSpace = true;
  },
  methods: {
      // 打开批量操作
    openEdit(){
      if (this.checkedApps.length == 0) {
        return this.$message.warning('请选择需要修改的应用！')
      }
      this.isEdit = true
    },
    // 批量操作的保存
    batchEidtSave(){
      const tempData = JSON.parse(JSON.stringify(this.showData))
      tempData.forEach((x, xIndex)=>{
        x.values.forEach((item, index)=>{
          if(this.checkedApps.map(item1=>{return item1.id}).indexOf(item.id) !== -1){
            for(let key in this.powerObj) {
              // this.$set(this.showData[xIndex].values[index], key, this.powerObj[key])
              this.showData[xIndex].values[index][key] = this.powerObj[key]
            }
          }
        })
      })
      this.batchEidtClose()
    },
    // 关闭批量操作
    batchEidtClose() {
      this.isEdit = false
      this.powerObj = this.$options.data().powerObj
    },
    groupBy(objectArray, property) {
      return objectArray.reduce(function (acc, obj) {
        let key = obj[property]
        if (!acc[key]) {
          acc[key] = []
        }
        acc[key].push(obj)
        return acc
      }, {})
    },
    // 要是选择了个人全部管辖数据的子项把之前的勾上
    batchChange(val, key, categoryKey){
    // 不做处理的选项
      const filterArr = ['myreportForm', 'reportForm', 'scope', 'approvalid', 'uncomplete', 'blockchain', 'chaindatacontrast']
      if(filterArr.indexOf(key) === -1 && val) {
        if (categoryKey === 'personData') {
          this.powerObj.myreportForm = val
        } else if (categoryKey === 'allData') {
          this.powerObj.reportForm = val
        } else if (categoryKey === 'governData') {
          this.powerObj.scope = val
        }
      } 
    },
    roleAuthorizationMethod (param) {
      this.data = param
      this.roleId = param.roleId
      const obj = {}
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = localStorage.getItem('spaceid');
        obj.spaceid = spaceId;
      }
      axiosBase(obj, "/api/getrolepermissionkey").then(res => {
        const tempData = JSON.parse(JSON.stringify(res.data))
        for (let key in tempData) {
          if (['workbench', 'submitformid', 'thirdApp'].indexOf(key) !== -1) {
            delete res.data[key]
          }
        }
        this.roleGrouplist = res.data;
        this.getrolelistEvent(Object.keys(res.data)[0], 0)

      });
      if (param.pers) {
        this.pers = JSON.parse(param.pers)
      }
    },
    goBack () {//返回
      this.$emit('roleAuthorizationBack', this.pers)
    },
    save () {
      const a = {};
      const reportForm = {}
      const myreportForm = {}
      const updatemyreport = {}
      const importmyreport = {}
      const deletemyreport = {}
      const importreport = {};
      const exportreport = {};
      const approvalid = {};
      const uncomplete = {}
      const blockchain = {}
      const chaindatacontrast = {}
      const updatereport = {}
      const exportfile = {}
      const uploadblockchain = {}
      const exportmyfile = {}
      const uploadmyblockchain = {}
      const batchupdate = {}
      const batchupdatemine = {}
      const archivemine = {}
      const archive = {}
      // 管辖范围
      const scope = {}
      const deletescope = {}
      const updatescope = {}
      const importscope = {}
      const exportscope = {}
      const exportscopefile = {}
      const uploadscopeblockchain = {}
      const batchupdatescope = {}
      const archivescope = {}
      const key = Object.keys(this.roleGrouplist)[this.active];
      this.showData.forEach(e => {
        if (this.type == 'approval') {
          if (e.values.length > 0) {
            e.values.forEach(l => {
              if (l.reportForm) {
                reportForm['id' + l.reportFormId] = l.reportFormId
              }
              if (l.myreportForm) {
                myreportForm['id' + l.id] = l.id
              }
              if (l.updatemyreport) {
                updatemyreport['id' + l.id] = l.id
              }
              if (l.importmyreport) {
                importmyreport['id' + l.id] = l.id
              }
              if (l.deletemyreport) {
                deletemyreport['id' + l.id] = l.id
              }
              if (l.importreport) {
                importreport['id' + l.id] = l.id
              }
              if (l.exportreport) {
                exportreport['id' + l.id] = l.id
              }
              if (l.approvalid) {
                approvalid['id' + l.id] = l.id
              }
              if (l.uncomplete) {
                uncomplete['id' + l.id] = l.id
              }
              if (l.blockchain) {
                blockchain['id' + l.id] = l.id
              }
              if (l.chaindatacontrast) {
                chaindatacontrast['id' + l.id] = l.id
              }
              if (l.updatereport) {
                updatereport['id' + l.id] = l.id
              }
              if (l.exportfile) {
                exportfile['id' + l.id] = l.id
              }
              if (l.uploadblockchain) {
                uploadblockchain['id' + l.id] = l.id
              }
              if (l.exportmyfile) {
                exportmyfile['id' + l.id] = l.id
              }
              if (l.uploadmyblockchain) {
                uploadmyblockchain['id' + l.id] = l.id
              }
              if (l.batchupdate) {
                batchupdate['id' + l.id] = l.id
              }
              if (l.batchupdatemine) {
                batchupdatemine['id' + l.id] = l.id
              }
              if (l.deletereport) {
                a['id' + l.id] = l.id
              }
              if (l.archivemine) {
                archivemine['id' + l.id] = l.id
              }
              if (l.archive) {
                archive['id' + l.id] = l.id
              }
              // 管辖范围
              if (l.scope) {
                scope['id' + l.id] = l.id
              }
              if (l.deletescope) {
                deletescope['id' + l.id] = l.id
              }
              if (l.updatescope) {
                updatescope['id' + l.id] = l.id
              }
              if (l.exportscope) {
                exportscope['id' + l.id] = l.id
              }
              if (l.importscope) {
                importscope['id' + l.id] = l.id
              }
              if (l.exportscopefile) {
                exportscopefile['id' + l.id] = l.id
              }
              if (l.uploadscopeblockchain) {
                uploadscopeblockchain['id' + l.id] = l.id
              }
              if (l.batchupdatescope) {
                batchupdatescope['id' + l.id] = l.id
              }
              if (l.archivescope) {
                archivescope['id' + l.id] = l.id
              }
            });
          }
        } else {
          if (e.checkedValues.length > 0) {
            e.checkedValues.forEach(l => {
              a['id' + l] = l
            });
          }
          if (e.checkedMyvalues && e.checkedMyvalues.length > 0) {
            e.checkedMyvalues.forEach(p => {
              a['id' + p] = p
            });
          }
        }
      });
      if (this.type == 'approval') {
        this.pers.reportForm = reportForm;
        this.pers.myreportForm = myreportForm;
        this.pers.updatemyreport = updatemyreport;
        this.pers.importmyreport = importmyreport;
        this.pers.deletemyreport = deletemyreport;
        this.pers.importreport = importreport;
        this.pers.exportreport = exportreport;
        this.pers.approvalid = approvalid;
        this.pers.uncomplete = uncomplete;
        this.pers.blockchain = blockchain;
        this.pers.chaindatacontrast = chaindatacontrast
        this.pers.updatereport = updatereport;
        this.pers.deletereport = a;
        this.pers.exportfile = exportfile;
        this.pers.uploadblockchain = uploadblockchain;
        this.pers.exportmyfile = exportmyfile;
        this.pers.uploadmyblockchain = uploadmyblockchain;
        this.pers.batchupdate = batchupdate;
        this.pers.batchupdatemine = batchupdatemine;
        this.pers.archivemine = archivemine;
        this.pers.archive = archive;
        // 管辖范围
        this.pers.scope = scope
        this.pers.deletescope = deletescope
        this.pers.updatescope = updatescope
        this.pers.importscope = importscope
        this.pers.exportscope = exportscope
        this.pers.exportscopefile = exportscopefile
        this.pers.uploadscopeblockchain = uploadscopeblockchain
        this.pers.batchupdatescope = batchupdatescope
        this.pers.archivescope = archivescope
      } else {
        this.pers[key] = a
      }
      const param = {
        roleId: this.roleId,
        pers: JSON.stringify(this.pers)
      };
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = localStorage.getItem('spaceid');
        param.spaceid = spaceId;
      }
      console.log("param====" + JSON.stringify(param));
      axiosBase(param, "/api/updaterole").then(res => {
        if (res.code == 0) {
          this.$message({ type: "success", message: "修改成功!" });
        } else {
          this.$message({ type: "info", message: "修改失败!" });
        }
      });
    },
    handleCheckAllChange (val, key, i) {
      if (i == 1) {//个人
        if (val) {
          this.showData[key].myvalues.forEach(l => {
            if (this.showData[key].checkedMyvalues.indexOf(l.id) === -1) {
              this.showData[key].checkedMyvalues.push(l.id)
            }
          })
        } else {
          this.showData[key].checkedMyvalues = [];
        }
        this.showData[key].isIndeterminates = false;
      } else {
        if (val) {
          this.showData[key].values.forEach(l => {
            if (this.showData[key].checkedValues.indexOf(l.id) === -1) {
              this.showData[key].checkedValues.push(l.id)
            }
          })
        } else {
          this.showData[key].checkedValues = [];
        }
        this.showData[key].isIndeterminate = false;
      }
    },
    handleCheckedCitiesChange (values, key, i) {
      let checkedCount = values.length;
      if (i == 1) {//个人
        this.showData[key].checkAlls = checkedCount === this.showData[key].myvalues.length;
        this.showData[key].isIndeterminates = checkedCount > 0 && checkedCount < this.showData[key].myvalues.length;
      } else {
        this.showData[key].checkAll = checkedCount === this.showData[key].values.length;
        this.showData[key].isIndeterminate = checkedCount > 0 && checkedCount < this.showData[key].values.length;
      }
    },
    newgroupSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // TODO
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 分类选择切换
    navClick (key) {
      // this.allChecked = false
      const len = this.showData[key].values.filter(item=>{
        return item.nameCheck
      }).length
      this.allChecked = len === this.showData[key].values.length ? true : false  
      this.listKey = key
    },
    // 全选只是选择应用
    allCheck (item) {
      this.showData[this.listKey].values.forEach(e => {
        e.nameCheck = item
        // if (item) {
        //   e.nameCheck = true
        //   e.approvalid = true
        //   e.uncomplete = true
        //   e.blockchain = true
        //   e.chaindatacontrast = true
        //   e.myreportForm = true
        // } else {
        //   e.nameCheck = false
        //   e.approvalid = false
        //   e.uncomplete = false
        //   e.blockchain = false
        //   e.chaindatacontrast = false
        //   e.myreportForm = false
        // }
      });

    },
    nameChecked (item, item1) {
      if (item) {
        item1.approvalid = true;
        item1.myreportForm = true;
      }
    },
    reportFormCheck (item, item1, type) {
      //type判断1个人数据和2全校数据，3管辖范围
      if (item) {
        if (type === 1) {
          item1.myreportForm = true;
        } else if(type === 2) {
          item1.reportForm = true;
        } else {
          item1.scope = true;
        }
      }
    },
    getrolelistEvent (key, index) {
      this.allChecked = false
      this.type = key
      this.active = index
      this.loading = true;
      const obj = { roleId: this.roleId, key: key }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = localStorage.getItem('spaceid');
        obj.spaceid = spaceId;
      }
      axiosBase(obj, '/api/getrolepermissionbykey').then(res => {//获取
        if (!res || res.data.length == 0) {
          this.$message({ type: "info", message: "暂无数据!" });
          this.loading = false;
          this.showData = [];
          return;
        }
        var a = [];
        if (key == 'report') {
          res.data.forEach(e => {
            e.checkedValues = []
            e.checkedMyvalues = []
            e.checkAll = false
            e.checkAlls = false
            e.isIndeterminate = true
            e.isIndeterminates = true
            for (var i in e.values) {
              if (e.values[i].checked) {
                e.checkedValues.push(e.values[i].id);
              }
            }
            for (var j in e.myvalues) {
              if (e.myvalues[j].checked) {
                e.checkedMyvalues.push(e.myvalues[j].id);
              }
            }
          })
          a = res.data
        } else {
          res.data.forEach((el) => {
            if (key == 'approval') {
              el.nameCheck = false
            }
            a.push({ categoryName: el.categoryName, values: [], checkedValues: [], checkAll: false, isIndeterminate: true });
          });
          let obj = {};
          a = a.reduce((cur, next) => {
            obj[next.categoryName] ? "" : (obj[next.categoryName] = true && cur.push(next));
            return cur;
          }, []); //设置cur默认类型为数组，并且初始值为空的数组
          res.data.forEach(e => {
            for (var i in a) {
              if (e.categoryName == a[i].categoryName) {
                a[i].values.push(e);
                if (e.checked) {
                  a[i].checkedValues.push(e.id);
                }
              }
            }
          });
        }
        this.showData = a
        this.loading = false
        for (var i = 0; i < a.length; i++) {
          this.handleCheckedCitiesChange(this.showData[i].checkedValues, i)
        }
      });
    },
  },
  mounted () {

  }
}
</script>

<style scoped lang="scss">
/* @import "css/roleAuthorization.css"; */

.organizationMain {
  width: 100%;
  height: 600px;
  .leftMenu {
    width: 253px !important;
    height: 100%;
    border-radius: 14px;
    overflow: hidden;
    display: inline-block;
    border-right: 1px solid rgba(240, 240, 240, 1);
    .menuList {
      ul li {
        display: inline-block;
        height: 40px;
        width: 100%;
        line-height: 40px;
        position: relative;
        cursor: pointer;
        span {
          padding-left: 34px;
          display: inline-block;
        }
        &.active {
          background: rgba(236, 244, 251, 1);
          color: rgba(56, 162, 251, 1);
          i {
            color: #4e86ff !important;
          }
          &::before {
            width: 4px;
            height: 40px;
            color: rgba(56, 162, 251, 1);
            position: absolute;
            left: 0;
            content: "";
          }
        }

        p {
          color: #666;
          cursor: pointer;
          position: relative;
          margin-left: 36px;
          &.admin::after {
            color: #f5a623;
          }
        }
        &::after {
          content: "\e68c";
          position: absolute;
          font-family: "iconfont";
          left: 12px;
          font-size: 16px;
          color: #4e86ff;
          top: 0px;
        }
      }
    }
  }
  .rightAppManager {
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 260px);
    height: 100%;
    .AppManager-title {
      overflow: hidden;
      .mangerBtnArea {
        float: left;
        display: inline-block;
        .button {
          display: inline-block;
          vertical-align: top;
          margin-left: 25px;
          margin-top: 9px;
        }
        .blue {
          color: #4e86ff;
        }
        .red {
          color: #e47470;
        }
      }
      .search-block {
        float: right;
        display: inline-block;
        height: 36px;
        margin-right: 9px;
        line-height: 38px;
        width: 50%;
        text-align: right;
        ::v-deep .el-input {
          width: 55%;
          .el-input__inner {
            width: 100%;
            background: #f2f2f2;
            border-radius: 6px;
            border: none;
          }
        }
        ::v-deep .el-button {
          display: inline-block;
          vertical-align: top;
          margin-left: 12px;
          padding: 7px 14px;
          margin-top: 6px;
        }
      }
    }
    .AppManager {
      padding: 15px 15px;
      height: calc(100% - 86px);
      overflow-x: scroll;
      /*修改滚动条样式*/
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        /**/
      }

      &::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 2px;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: rgba(0, 0, 0, 0.5);
      }

      &::-webkit-scrollbar-corner {
        background: transparent;
      }
      .AppManager-list {
        border-radius: 10px;
        border: 1px solid #e5e5e5;
        display: flex;
        margin-bottom: 10px;

        .tit {
          flex: 1;
          font-size: 16px;
          position: relative;
          border-right: 1px solid #eee;
          padding: 10px 11px;
          span {
            color: #4e86ff;
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .con {
          flex: 8;
          margin-left: 20px;
          .databox {
            position: relative;
            p {
              padding: 4px 10px;
              color: #000;
            }
            .checkboxGroup {
              margin-right: 80px;
              padding: 10px 10px 10px 0;
            }
            .checkAllBox {
              position: absolute;
              bottom: 35%;
              right: -15px;
            }
          }
        }
        ::v-deep .el-checkbox {
          margin: 5px 30px 0 0;
          display: inline-block;
        }
      }
      .approvalBox {
        box-shadow: 0px 0px 12px #ebeef7;
        border-radius: 4px;
        overflow: hidden;
        .nav {
          width: 12%;
          float: left;
          border-right: 1px solid #eee;
          height: 100%;
          p {
            padding: 12px 6px;
            text-align: center;
            cursor: pointer;
            color: #333333;
            &.active {
              background: rgba(236, 244, 251, 1);
              color: rgba(56, 162, 251, 1);
            }
          }
        }
        .list {
          float: left;
          width: 87.8%;
          border-left: 1px solid #eee;
          .tit {
            border-bottom: 1px solid #eee;
            padding: 16px 20px;
            i {
              color: #f5a623;
              margin-left: 12px;
              cursor: pointer;
            }
            ::v-deep .el-button{
              padding: 4px 12px;
              margin-left: 12px;
            }
            span {
              position: relative;
              margin-left: 12px;
            }
          }
          .list_d {
            border: 1px solid #eee;
            margin: 20px;
            overflow: hidden;
            width: 96%;
            border-radius: 14px;
            div .el-checkbox {
              color: #000;
              word-break: break-all;
            }
            .name {
              float: left;
              width: 18%;
              word-break: break-all;
              p {
                overflow: hidden;
                margin-top: 54%;
                margin-left: 11%;
              }
            }
            .rightList {
              float: left;
              width: 81%;
              border-left: 1px solid #eee;
              overflow: hidden;
              & > div {
                line-height: 80px;
                padding: 0 24px;
                overflow: hidden;
              }
              &.rightList .schoolData {
                border: 1px solid #ddd;
                line-height: 56px;
                margin: 0 9px 20px 20px;
                width: auto;
                border-radius: 5px;
                padding: 0;
                overflow: hidden;
                p {
                  padding: 0 11px 0 16px;
                  float: left;
                  .el-checkbox {
                    color: #333333;
                  }
                  &.name-t {
                    // background: #fff;
                    border-right: 1px dashed #ddd;
                    .el-checkbox {
                      color: #000;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
::v-deep .pack-content {
  padding: 0 !important;
}
.bottom-btn {
  height: 64px;
  line-height: 64px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -2px 5px 0px rgba(140, 158, 173, 0.07);
  padding-right: 16px;
  ::v-deep .el-button {
    padding: 8px 22px;
    border-radius: 4px;
  }
}
// 批量操作的弹出框
.batch-eidt-box {
  height: 40vh;
  display: flex;
  border-bottom: 1px solid #d6d4d4;
  overflow: hidden;
  &-left{
    height: 100%;
    width: 208px;
    border-right: 1px solid #d6d4d4;
    padding-top: 16px;
    p, li{
      height: 40px;
      line-height: 40px;
    }
    p {
      padding-left: 8px;
      span {
        padding-left: 4px;
      }
    }
    li {
      padding-left: 32px;
    }
  }
  &-right{
    padding-top: 16px;
    flex: 1;
    height: 100%;
    padding-left: 8px;
    
    .checkbox-group {
      padding: 8px 16px;
      margin-bottom: 8px;
      border: 1px solid #d6d4d4;
      border-radius: 4px;
    }
  }
}
.bb-eee {
  border-bottom: 1px solid #eee;
}
.bt-eee {
  border-top: 1px solid #eee;
}

@media screen and (max-width: 1500px) {
  .approvalBox .list .list_d > div.rightList .schoolData {
    margin-left: 24px;
  }
}
</style>
